/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Injectable } from '@angular/core'
import { EMPTY, Observable, of, Subject } from 'rxjs'
import { PidxNotification } from './models/pidx-notification'
import { PidxNotificationType } from './models/pidx-notification-type.enum'

@Injectable({
  providedIn: 'root',
})
export class PidxBannerService {
  protected _notifications: Subject<PidxNotification> = new Subject<PidxNotification>()
  public notifications: Observable<PidxNotification>

  constructor() {
    this.notifications = this._notifications.asObservable()
  }

  addNotification(notification: PidxNotification) {
    this._notifications.next(notification)
  }

  addPageBlockingError(translatedString: string) {
    this.addNotification({
      translatedString,
      type: PidxNotificationType.ERROR,
      blocksPage: true,
      open: true,
    })
  }

  public queueAddNotification(notifications: PidxNotification[], notification: PidxNotification) {
    return notifications.filter((ele: PidxNotification) => {
      return ele.translatedString === notification.translatedString
    }).length
      ? EMPTY
      : of(null)
  }
}
